import { useTheme } from 'styled-components';
import useClinicInformationPageController from '../../1_application/setting/clinicInformationPageController';
import { Clinic } from '../../2_domain/clinic/clinic';
import IClinicRepository from '../../2_domain/clinic/iClinicRepository';
import withAsync from '../../lib/asyncBounrdary/withAsync';
import wrapPromise from '../../lib/asyncBounrdary/wrapPromise';
import Get from '../../lib/di/get';
import BoxContainer from '../core/components/box/boxContainer';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import LXLargeButton from '../core/components/buttons/lxLargeButton';
import { XCenter } from '../core/components/center';
import { HorizontalDivider } from '../core/components/divider/lxDivider';
import LXError from '../core/error/lx_error';
import LXSpinner from '../core/spinner/lx_spinner';
import { LXLabelInput } from '../core/texts/lxInput';
import { LXbody, LXh2, LXh4, LXh5 } from '../core/texts/lxText';

interface ClinicInformationProps {
  clinic: Clinic;
}

const ClinicInformation = (props: ClinicInformationProps) => {
  const theme = useTheme();
  const c = useClinicInformationPageController(props.clinic);

  const clinicForm = (
    <Column>
      <LXh5>{`${theme.texts.clinicNo} ${c.clinic.serial}`}</LXh5>
      <SizedBox height={24}></SizedBox>
      <Row>
        <LXLabelInput
          width={320}
          label={theme.texts.clinicName}
          value={c.clinicName}
          onChange={c.setClinicName}
          placeholder={theme.texts.enterName}
        ></LXLabelInput>
        <SizedBox width={24}></SizedBox>
        <LXLabelInput
          width={320}
          label={theme.staff.doctor}
          value={c.ceoName}
          onChange={c.setCeoName}
          placeholder={theme.texts.enterName}
        ></LXLabelInput>
      </Row>
      <SizedBox height={24}></SizedBox>
      <Row>
        <LXLabelInput
          width={320}
          label={theme.texts.phone}
          value={c.phone}
          onChange={c.setPhone}
          placeholder={theme.texts.enterPhoneNumber}
        ></LXLabelInput>
        <SizedBox width={24}></SizedBox>
        <LXLabelInput
          disabled={true}
          width={320}
          label={theme.texts.email}
          value={c.email}
          onChange={c.setEmail}
          placeholder={theme.texts.exampleEmail}
        ></LXLabelInput>
      </Row>
      <SizedBox height={24}></SizedBox>
      <Row>
        <LXLabelInput
          width={320}
          label={theme.texts.websiteOptional}
          value={c.website}
          onChange={c.setWebsite}
          placeholder={theme.texts.enterWebsite}
        ></LXLabelInput>
        <SizedBox width={24}></SizedBox>
        <LXLabelInput
          width={320}
          label={theme.texts.faxOptional}
          value={c.fax}
          onChange={c.setFax}
          placeholder={theme.texts.enterFax}
        ></LXLabelInput>
      </Row>
      <SizedBox height={30} />
      <HorizontalDivider></HorizontalDivider>
      <SizedBox height={30} />
      <LXLabelInput
        width={664}
        label={theme.texts.streetAddress}
        value={c.streetAddress}
        onChange={c.setStreetAddress}
      ></LXLabelInput>
      <SizedBox height={24}></SizedBox>
      <LXLabelInput
        width={664}
        label={theme.texts.aptSuiteEtcOptional}
        value={c.additionalAddress}
        onChange={c.setAdditionalAddress}
      ></LXLabelInput>
      <SizedBox height={24}></SizedBox>
      <Row>
        <LXLabelInput
          width={320}
          label={theme.texts.city}
          value={c.city}
          onChange={c.setCity}
        ></LXLabelInput>
        <SizedBox width={24}></SizedBox>
        <LXLabelInput
          width={320}
          label={theme.texts.zip}
          value={c.zip}
          onChange={c.setZip}
        ></LXLabelInput>
      </Row>
    </Column>
  );

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        <LXh2>{theme.texts.clinicInformation}</LXh2>
        <SizedBox height={20}></SizedBox>
        <Row justifyContent="end">
          <LXLargeButton onClick={c.onSaveHandler}>
            {theme.texts.save}
          </LXLargeButton>
        </Row>
        <SizedBox height={16}></SizedBox>
        <BoxContainer padding="30px 30px 40px">
          <LXh4>{theme.texts.enterClinicInformation}</LXh4>
          <SizedBox height={4}></SizedBox>
          <LXbody color={theme.colors.caption}>
            {theme.texts.pleaseEnterTheRequiredInformation}
          </LXbody>
          <SizedBox height={40}></SizedBox>
          <XCenter>{clinicForm}</XCenter>
        </BoxContainer>
      </Column>
    </XCenter>
  );
};

const ClinicInformationWarpper = () => {
  const clinicRepo = Get.find<IClinicRepository>('IClinicRepository');
  const clinic = wrapPromise<void, Clinic>(
    clinicRepo.getClinicInformation,
    undefined,
    'clinicRepoKey'
  )();

  return <ClinicInformation clinic={clinic}></ClinicInformation>;
};

export default withAsync({
  child: ClinicInformationWarpper,
  suspenseFallback: <LXSpinner></LXSpinner>,
  errorFallback: <LXError></LXError>,
});
